// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@turnerBlueprint/XDL/Icons/Close";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { xBaseTheme } from "@turnerBlueprint/XDL/types";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 420,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
                line-height: 21px;
            `,
            modalTitle: css`
                position: relative;
                padding: 16px 16px 8px 16px;
                border-bottom: 0;
                &:has(> div:empty) {
                    &:after {
                        display: none;
                    }
                }
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: calc(100% - 32px);
                    height: 1px;
                    background-color: ${color("common.border")};
                    margin: 0 auto;
                }
            `,
            modalContent: css`
                padding: 16px;
            `,
            modalBody: css`
                border-radius: 2px;
                background-color: ${color("common.white")};
                box-shadow: none;
                border: 1px solid ${color("common.border")};
                ${xScreen("gt", "md")} {
                    box-shadow: none;
                }
                ${xScreen("lt", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                }
            `,
        },
        headlineTypographyProps: {
            size: 18,
            weight: fontConfig.weight.bold,
            lineHeight: "21px",
        },
        closeButtonProps: {
            mergeCss: true,
            css: css`
                width: 24px;
                height: 24px;
                padding: 0;
                min-height: initial;
                background-color: transparent;
                & > ${IconWrapper} {
                    top: 0;
                    color: ${color("common.ui5")};
                }
                &:not(:disabled):hover,
                &:not(:disabled):focus {
                    background: none;
                    border-color: transparent;
                    > ${IconWrapper} {
                        color: ${color("common.ui9")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 12,
            color: "common.ui5",
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
